module.exports = __webpack_public_path__ + "img/75.9.TU.70bdc70e.png";